import React, {createContext, useContext, useReducer} from 'react'
import {BagTrackingReducer} from "../reducer/BagTrackingReducer";
import {PermissionsContext} from "../../../permissions/PermissionsContext";
import PermissionAlertBanner from "../../../commonui/PermissionAlertBanner";

export const BagTrackingContext = createContext()

const BagTrackingContextProvider = (props) => {
    const state = {
        bagList: {},
        loadingOverview: true
    }
    const [ viewModel, dispatch ] = useReducer(BagTrackingReducer, state);
    const {isAuthorised} = useContext(PermissionsContext);

    if (!isAuthorised){
        return (
            <PermissionAlertBanner/>
        );
    }

    return (
        <BagTrackingContext.Provider value = {{viewModel, dispatch}}>
            {props.children}
        </BagTrackingContext.Provider>
    )
};

export default BagTrackingContextProvider;


// WEBPACK FOOTER //
// ./src/components/devicemanagement/bagtracking/context/BagTrackingContext.js